import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, ArrowRight, CheckCircle } from 'lucide-react'
import axiosInstance from '../../services/axiosInstance'
import './styles.scss'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setSuccess(false)

    try {
      const response = await axiosInstance.post('/api/auth/forgot-password', { email })
      if (response.data.success) {
        setSuccess(true)
      } else {
        setError(response.data.message || 'Failed to request password reset.')
      }
    } catch (err) {
      console.error(err)
      setError(err.response?.data?.message || 'An unexpected error occurred. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-brand">
        <div className="auth-brand__dots" />
        <div className="auth-brand__content">
          <div className="auth-brand__logo">
            <img src="/campusready_logo.svg" alt="CampusReady" />
            <span>CampusReady<span className="ai">.ai</span></span>
          </div>
          <h1>Password Recovery</h1>
          <p>
            Enter your email address and we'll send you a secure link to reset your password.
          </p>
          <div className="auth-brand__features">
            <span className="feature-pill">Secure</span>
            <span className="feature-pill">Fast</span>
            <span className="feature-pill">Reliable</span>
          </div>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h2>Reset Password</h2>
            <p>We'll help you get back to your account.</p>
          </div>

          {error && (
            <div className="auth-error">
              <span>{error}</span>
            </div>
          )}

          {success ? (
            <div className="auth-form">
              <div style={{ textAlign: 'center', padding: '2rem 1rem' }}>
                <CheckCircle size={48} color="#10B981" style={{ marginBottom: '1rem' }} />
                <h3 style={{ marginBottom: '0.5rem', color: '#0F172A' }}>Check your email</h3>
                <p style={{ color: '#64748B', lineHeight: '1.5' }}>
                  If an account exists for <strong>{email}</strong>, we've sent a password reset link to it.
                </p>
              </div>
              <Link to="/login" className="auth-submit" style={{ textDecoration: 'none' }}>
                Return to Sign In
              </Link>
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@university.edu"
                  required
                  autoFocus
                />
              </div>

              <button type="submit" className="auth-submit" disabled={loading || !email}>
                {loading ? (
                  <span className="spinner" />
                ) : (
                  <>Send Reset Link <ArrowRight size={16} /></>
                )}
              </button>
            </form>
          )}

          {!success && (
            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
              <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#64748B', textDecoration: 'none', fontSize: '0.9rem', fontWeight: '500' }}>
                <ArrowLeft size={16} /> Back to Sign In
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
